/** `resetFix` translations, for every locale -- correcting a year-end CL/PSL reset on the Leave page. */
export const resetFix = {
  mn: {
    resetFix: {
      open: '{{year}} оны шилжүүлгийг засах',
      title: '{{name}}: {{year}} оны жилийн эцсийн шилжүүлэг',
      clLapsed: 'Шатсан CL',
      pslLapsed: 'Шатсан PSL',
      comment: 'Тайлбар',
      help: '{{year}} оны 12-р сарын 31-ний шилжүүлгээр шатсан гэж бүртгэгдсэн өдрийг тухайн мөрөнд нь засна. Шатсан PSL-ийг {{next}} оны 1-р сарын эцсийн цалин олгоно, тиймээс түүнийг гаргасны дараа энд засах боломжгүй.',
      save: 'Засварыг хадгалах',
      saved: '{{year}} оны шилжүүлгийг засварлалаа',
      notANumber: 'Шатсан өдөр 0 буюу түүнээс их тоо байх ёстой.',
      nothingChanged: 'Аль нэг тоог өөрчилнө үү: одоогийн тоонууд бүртгэгдсэнтэй ижил байна.',
      noComment: 'Яагаад засаж байгаагаа тайлбарт бичнэ үү.',
      paid: '{{next}} оны 1-р сарын эцсийн цалин гарсан тул {{year}} оны шилжүүлгийг энд засах боломжгүй. Гараар засна уу.',
      noReset: '{{name}}-д {{year}} оны жилийн эцсийн шилжүүлэг хийгдээгүй тул засах зүйл алга.',
      failed: '{{year}} оны шилжүүлгийг засаж чадсангүй: {{detail}}',
    },
  },
  en: {
    resetFix: {
      open: 'Correct {{year}} reset',
      title: '{{name}}: the {{year}} year-end reset',
      clLapsed: 'CL lapsed',
      pslLapsed: 'PSL lapsed',
      comment: 'Comment',
      help: 'Changes the days the 31 December {{year}} reset recorded as lapsed, on that reset’s own row. The January {{next}} final pays the lapsed PSL, so once it is issued this can no longer be changed here.',
      save: 'Save correction',
      saved: '{{year}} reset corrected',
      notANumber: 'Lapsed days must be a number of 0 or more.',
      nothingChanged: 'Change a figure first: both still match what the reset recorded.',
      noComment: 'Say in the comment why you are correcting it.',
      paid: 'The January {{next}} final is already issued, so the {{year}} reset can no longer be changed here. Correct it by hand.',
      noReset: 'No {{year}} year-end reset ran for {{name}}, so there is nothing to correct.',
      failed: 'Could not correct the {{year}} reset: {{detail}}',
    },
  },
  ru: {
    resetFix: {
      open: 'Исправить сброс {{year}}',
      title: '{{name}}: сброс на конец {{year}} года',
      clLapsed: 'Сгорело CL',
      pslLapsed: 'Сгорело PSL',
      comment: 'Комментарий',
      help: 'Меняет дни, которые сброс 31 декабря {{year}} записал как сгоревшие, в строке самого сброса. Сгоревший PSL оплачивает январский окончательный расчёт {{next}} года, поэтому после его выдачи изменить это здесь нельзя.',
      save: 'Сохранить исправление',
      saved: 'Сброс {{year}} исправлен',
      notANumber: 'Сгоревшие дни должны быть числом не меньше 0.',
      nothingChanged: 'Сначала измените число: оба совпадают с тем, что записал сброс.',
      noComment: 'Укажите в комментарии, почему вы исправляете.',
      paid: 'Январский окончательный расчёт {{next}} года уже выдан, поэтому сброс {{year}} здесь больше не изменить. Исправьте вручную.',
      noReset: 'Для {{name}} сброс на конец {{year}} года не выполнялся, исправлять нечего.',
      failed: 'Не удалось исправить сброс {{year}}: {{detail}}',
    },
  },
}
